import { ISelectOption }             from '@typings/components';
import { EUserStatus, EMonthNumber } from '@enums/common';

export const USER_STATUS_NAME: Record<EUserStatus, string> = {
  [EUserStatus.Unconfirmed] : 'Unconfirmed',
  [EUserStatus.Inactive]    : 'Suspend',
  [EUserStatus.Active]      : 'Active',
  [EUserStatus.Banned]      : 'Inactive; Too many complaints',
};

export const MONTH_SHORTNAME_BY_NUMBER: Record<EMonthNumber, string> = {
  [EMonthNumber.Jan] : 'Jan',
  [EMonthNumber.Feb] : 'Feb',
  [EMonthNumber.Mar] : 'Mar',
  [EMonthNumber.Apr] : 'Apr',
  [EMonthNumber.May] : 'May',
  [EMonthNumber.Jun] : 'Jun',
  [EMonthNumber.Jul] : 'Jul',
  [EMonthNumber.Aug] : 'Aug',
  [EMonthNumber.Sep] : 'Sep',
  [EMonthNumber.Oct] : 'Oct',
  [EMonthNumber.Nov] : 'Nov',
  [EMonthNumber.Dec] : 'Dec',
};

export const MONTH_FULLNAME_BY_NUMBER: Record<EMonthNumber, string> = {
  [EMonthNumber.Jan] : 'January',
  [EMonthNumber.Feb] : 'February',
  [EMonthNumber.Mar] : 'March',
  [EMonthNumber.Apr] : 'April',
  [EMonthNumber.May] : 'May',
  [EMonthNumber.Jun] : 'June',
  [EMonthNumber.Jul] : 'July',
  [EMonthNumber.Aug] : 'August',
  [EMonthNumber.Sep] : 'September',
  [EMonthNumber.Oct] : 'October',
  [EMonthNumber.Nov] : 'November',
  [EMonthNumber.Dec] : 'December',
};

export const stateOptions: ISelectOption[] = [
  { label: 'Alabama',        value: 'AL' },
  { label: 'Alaska',         value: 'AK' },
  { label: 'Arizona',        value: 'AZ' },
  { label: 'Arkansas',       value: 'AR' },
  { label: 'California',     value: 'CA' },
  { label: 'Colorado',       value: 'CO' },
  { label: 'Connecticut',    value: 'CT' },
  { label: 'Delaware',       value: 'DE' },
  { label: 'Florida',        value: 'FL' },
  { label: 'Georgia',        value: 'GA' },
  { label: 'Hawaii',         value: 'HI' },
  { label: 'Idaho',          value: 'ID' },
  { label: 'Illinois',       value: 'IL' },
  { label: 'Indiana',        value: 'IN' },
  { label: 'Iowa',           value: 'IA' },
  { label: 'Kansas',         value: 'KS' },
  { label: 'Kentucky',       value: 'KY' },
  { label: 'Louisiana',      value: 'LA' },
  { label: 'Maine',          value: 'ME' },
  { label: 'Maryland',       value: 'MD' },
  { label: 'Massachusetts',  value: 'MA' },
  { label: 'Michigan',       value: 'MI' },
  { label: 'Minnesota',      value: 'MN' },
  { label: 'Mississippi',    value: 'MS' },
  { label: 'Missouri',       value: 'MO' },
  { label: 'Montana',        value: 'MT' },
  { label: 'Nebraska',       value: 'NE' },
  { label: 'Nevada',         value: 'NV' },
  { label: 'New Hampshire',  value: 'NH' },
  { label: 'New Jersey',     value: 'NJ' },
  { label: 'New Mexico',     value: 'NM' },
  { label: 'New York',       value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota',   value: 'ND' },
  { label: 'Ohio',           value: 'OH' },
  { label: 'Oklahoma',       value: 'OK' },
  { label: 'Oregon',         value: 'OR' },
  { label: 'Pennsylvania',   value: 'PA' },
  { label: 'Rhode Island',   value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota',   value: 'SD' },
  { label: 'Tennessee',      value: 'TN' },
  { label: 'Texas',          value: 'TX' },
  { label: 'Utah',           value: 'UT' },
  { label: 'Vermont',        value: 'VT' },
  { label: 'Virginia',       value: 'VA' },
  { label: 'Washington',     value: 'WA' },
  { label: 'West Virginia',  value: 'WV' },
  { label: 'Wisconsin',      value: 'WI' },
  { label: 'Wyoming',        value: 'WY' },
];

export const ROWS_PER_PAGE = 20;
